<template>
	<!-- width="390px" -->
	<!-- <el-aside class="layout-chat-left"> -->
	<div class="layout-chat-left">
		<div class="search-panel">
			<!-- <el-button @click="createChat" type="primary" size="small"><i class="el-icon-plus"></i></el-button> -->
			<el-input v-model="searchWord" @input="filter" size="large" placeholder="搜索" prefix-icon="el-icon-search" />
		</div>

		<div class="chats-panel pt10">
			<div class="chat-item-box" v-for="(item, idx) of _chatList" :key="idx">
				<div v-show="item.visible" :class="_chatingId == item.guid ? 'active' : ''" class="chat-item"
					@click="chooseChat(item)">
					<div class="chat-name-box">
						<div class="name">
							<!-- 置顶标识：让用户一眼看出哪些被置顶 -->
							<i v-if="item.isTop" class="el-icon-top top-flag" title="已置顶"></i>
							<span>{{ item.chatLunciTitle }}</span>
						</div>
						<!-- 日期 + 置顶按钮 同行展示，避免下方操作区按钮过多被挤压 -->
						<div class="date-row">
							<span class="date">{{ item.showTime }}</span>
							<span class="top-btn" :class="{ active: item.isTop }"
								@click.stop="toggleLunciTop(item)"
								:title="item.isTop ? '点击取消置顶' : '点击置顶'">
								<i :class="item.isTop ? 'el-icon-download' : 'el-icon-top'"></i>
								{{ item.isTop ? '取消置顶' : '置顶' }}
							</span>
						</div>
					</div>
				</div>
				<div class="chat-icon-box">
					<div class="opts">
						<div @click="modifyDialog" class="item">
							<i class="el-icon-edit"></i>编辑
						</div>
						<div class="item">
							<el-popconfirm @confirm="removeChatDialog(item.guid)" title="确定删除吗 ？">
								<span slot="reference"><i class="el-icon-delete"></i>删除</span>
							</el-popconfirm>
						</div>
						<div class="item" @click="generateAgent(item)">
							<span slot="reference"><i class="el-icon-discount"></i>生成智能体</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div class="btn-box">
			<div @click="createChat" class="add-chat-btn" :style="_creating ? 'opacity:0.6;pointer-events:none' : ''">
				<i v-if="_creating" class="el-icon-loading"></i>
				<img v-else class="icon" src="@/static/icon/chat-add-icon.png" />
				{{ _creating ? '创建中…' : '新增对话' }}
			</div>
		</div>
		<!-- 消息选择弹窗 -->
	<el-dialog title="选择用于生成智能体的消息" :visible.sync="showMsgSelectDialog" width="640px" @close="showMsgSelectDialog = false">
		<div v-if="loadingMessages" class="msg-loading">
			<i class="el-icon-loading"></i> 正在加载消息...
		</div>
		<div v-else>
			<!-- 系统提示词 -->
			<div v-if="currentSystemPrompt" class="system-prompt-section">
				<div class="system-prompt-header" @click="includeSystemPrompt = !includeSystemPrompt">
					<el-checkbox :value="includeSystemPrompt" @change="includeSystemPrompt = !includeSystemPrompt" @click.native.stop />
					<span class="system-prompt-label"><i class="el-icon-setting"></i> 系统提示词</span>
					<span class="system-prompt-hint">（该轮次的角色设定）</span>
				</div>
				<div v-if="includeSystemPrompt" class="system-prompt-preview">{{ currentSystemPrompt | truncate(120) }}</div>
			</div>

			<!-- 消息列表 -->
			<div class="msg-select-tip">
				<span>已选 {{ selectedMsgIndexes.length }} / {{ chatMessages.length }} 条对话</span>
				<el-button type="text" size="small" @click="toggleSelectAll">
					{{ selectedMsgIndexes.length === chatMessages.length ? '全不选' : '全选' }}
				</el-button>
			</div>
			<div class="msg-select-list">
				<div
					v-for="(msg, idx) in chatMessages"
					:key="idx"
					class="msg-select-item"
					:class="{ selected: selectedMsgIndexes.includes(idx), 'is-user': msg.chatRole === 'user' }"
					@click="toggleMsg(idx)"
				>
					<el-checkbox :value="selectedMsgIndexes.includes(idx)" @change="toggleMsg(idx)" @click.native.stop />
					<div class="msg-body">
						<span class="msg-role">{{ msg.chatRole === 'user' ? '用户' : 'AI' }}</span>
						<span class="msg-content">{{ msg.chatContent | truncate(80) }}</span>
					</div>
				</div>
			</div>
		</div>
		<div slot="footer">
			<div v-if="generating" class="generate-tip">AI 正在分析对话生成智能体，请耐心等待 1~2 分钟</div>
			<el-button @click="showMsgSelectDialog = false">取消</el-button>
			<el-button type="primary" :disabled="selectedMsgIndexes.length === 0" @click="confirmMsgSelection" :loading="generating">
				确认并生成（{{ selectedMsgIndexes.length }}条）
			</el-button>
		</div>
	</el-dialog>

	<el-dialog title="创建智能体" :visible.sync="showDialog" width="800px" @close="resetForm">
			<el-form :model="agentForm" :rules="formRules" ref="agentForm" label-width="120px">
				<!-- 头像区域：支持手动上传（AI 解析已自动塞默认头像，这里允许用户覆盖） -->
				<el-form-item label="智能体头像">
					<div class="avatar-upload-section">
						<div class="avatar-preview">
							<el-upload class="avatar-uploader"
								:action="`${config.baseUrl}user/api.userinfo/uploadImg`"
								:show-file-list="false" name="img"
								:on-success="handleAvatarSuccess"
								:before-upload="beforeAvatarUpload">
								<div class="relative">
									<img :src="agentForm.agentAvatar || defaultAvatar" class="avatar-image" />
									<div class="uploading flex-center" v-show="uploading">
										<i class="spin el-icon-loading"></i>
									</div>
									<div class="btn-edit" title="点击上传头像">
										<i class="el-icon-upload2"></i>
									</div>
								</div>
							</el-upload>
						</div>
					</div>
				</el-form-item>

				<!-- 基本信息 -->
				<el-form-item label="选择分类" prop="categoryGuid">
					<el-select v-model="agentForm.categoryGuid" placeholder="请选择分类" style="width: 100%">
						<el-option v-for="category in categoryList" :key="category.guid" :label="category.categoryName"
							:value="category.guid">
						</el-option>
					</el-select>
				</el-form-item>

				<el-form-item label="智能体名称" prop="agentName">
					<el-input v-model="agentForm.agentName" placeholder="请输入智能体名称" maxlength="50" show-word-limit />
				</el-form-item>

				<el-form-item label="智能体描述" prop="agentDesc">
					<el-input v-model="agentForm.agentDesc" type="textarea" :rows="3" placeholder="请输入智能体描述" />
				</el-form-item>

				<!-- 智能体类型 -->
				<el-form-item label="智能体类型">
					<el-radio-group v-model="agentForm.agentType">
						<el-radio v-for="type in agentTypes" :key="type.value" :label="type.value">
							{{ type.label }}
						</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- 角色设定提示词 - 仅内部类型显示 -->
				<el-form-item label="角色设定提示词" prop="promptContent" v-if="agentForm.agentType === 1">
					<el-input v-model="agentForm.promptContent" type="textarea" :rows="5" placeholder="请输入角色设定提示词" />
				</el-form-item>

				<!-- AI 模型 - 仅内部类型显示，对齐我的智能体页 -->
				<el-form-item label="AI 模型" v-if="agentForm.agentType === 1">
					<div class="picker-trigger" @click="openAiModelPicker">
						<span class="picker-text" :class="{ 'placeholder': !agentForm.aiModelGuid }">
							{{ agentForm.aiModelGuid ? currentAiModelLabel : '请选择 AI 模型（可选，默认使用平台模型）' }}
						</span>
						<i v-if="agentForm.aiModelGuid" class="el-icon-close picker-clear" @click.stop="clearAiModel"></i>
						<i v-else class="el-icon-arrow-right picker-arrow"></i>
					</div>
					<div class="form-tip">不同模型每次回复扣除的聊天点数不同，选择前请确认点数成本</div>
				</el-form-item>

				<!-- MCP 服务器 - 仅内部类型显示 -->
				<el-form-item label="MCP 服务器" v-if="agentForm.agentType === 1">
					<div class="picker-trigger" @click="openMcpPicker">
						<span class="picker-text" :class="{ 'placeholder': !agentForm.mcpServerGuid }">
							{{ agentForm.mcpServerGuid ? currentMcpServerName : '请选择 MCP 服务器（可选）' }}
						</span>
						<i class="el-icon-arrow-right picker-arrow"></i>
					</div>
					<div class="form-tip">选择要绑定的 MCP 服务器，不选表示不启用 MCP 工具</div>
				</el-form-item>

				<!-- MCP 参数配置 - 选中 MCP 且模板非空时显示 -->
				<el-form-item label="MCP 参数配置"
					v-if="agentForm.agentType === 1 && agentForm.mcpServerGuid && agentForm.mcpConfigParam.length > 0">
					<div class="mcp-param-list">
						<div class="mcp-param-item" v-for="(param, idx) in agentForm.mcpConfigParam" :key="param.field">
							<div class="mcp-sub-label">{{ param.field_name || param.field }}</div>
							<el-input v-model="agentForm.mcpConfigParam[idx].value"
								:placeholder="param.desc || ('请输入' + (param.field_name || param.field))" />
						</div>
					</div>
				</el-form-item>

				<!-- 商品搜索触发描述 - 选中 MCP 时显示 -->
				<el-form-item label="商品搜索触发描述"
					v-if="agentForm.agentType === 1 && agentForm.mcpServerGuid">
					<el-input v-model="agentForm.toolDesc" type="textarea" :rows="3"
						:placeholder="DEFAULT_TOOL_DESC" maxlength="500" show-word-limit />
					<div class="form-tip">控制 AI 在何种情况下触发商品搜索，留空则使用默认描述</div>
				</el-form-item>

				<!-- 密钥读取类型 - 非内部类型显示 -->
				<el-form-item label="密钥读取类型" v-if="agentForm.agentType !== 1">
					<el-radio-group v-model="agentForm.agentConfig.secret_key_type">
						<el-radio v-for="type in secretTypes" :key="type.value" :label="type.value">
							{{ type.label }}
						</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- 扣子智能体ID - 仅Coze类型显示 -->
				<el-form-item label="扣子智能体ID" v-if="agentForm.agentType === 3">
					<el-input v-model="agentForm.agentConfig.coze_sign" placeholder="请输入扣子智能体ID" />
				</el-form-item>

				<!-- 智能体秘钥 - 非内部类型显示 -->
				<el-form-item label="智能体秘钥" v-if="agentForm.agentType !== 1">
					<el-input v-model="agentForm.agentConfig.secret_token" placeholder="请输入智能体秘钥" type="password" show-password />
				</el-form-item>

				<!-- Dify自定义部署地址 - 仅Dify类型显示 -->
				<el-form-item label="Dify部署地址" v-if="agentForm.agentType === 2">
					<el-input v-model="agentForm.agentConfig.deploy_address" placeholder="请输入Dify自定义部署地址" />
				</el-form-item>

				<!-- 开场白 -->
				<el-form-item label="开场白">
					<el-input v-model="agentForm.welcomeMessage" placeholder="请输入开场白" />
				</el-form-item>

				<!-- 引导问题列表 -->
				<el-form-item label="引导问题">
					<div class="question-list">
						<el-input v-for="(question, index) in agentForm.commonQuestions" :key="index"
							v-model="agentForm.commonQuestions[index]" :placeholder="`请输入引导问题${index + 1}`"
							style="margin-bottom: 8px;" />
					</div>
				</el-form-item>

				<!-- 智能体类型（免费/付费） -->
				<el-form-item label="智能体类型">
					<el-radio-group v-model="agentForm.isPaid">
						<el-radio v-for="type in visibilityTypes" :key="type.value" :label="type.value">
							{{ type.label }}
						</el-radio>
					</el-radio-group>
				</el-form-item>

				<!-- 收费金额 - 仅付费类型显示 -->
				<el-form-item label="收费金额" prop="price" v-if="agentForm.isPaid === 1">
					<el-input v-model="agentForm.price" placeholder="请输入收费金额" type="number" step="0.01">
						<template slot="append">元</template>
					</el-input>
				</el-form-item>

				<!-- 试用聊天次数 - 仅付费类型显示 -->
				<el-form-item label="试用聊天次数" v-if="agentForm.isPaid === 1">
					<el-input v-model="agentForm.trial_chat_count" placeholder="请输入试用聊天次数" type="number">
						<template slot="append">次</template>
					</el-input>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="showDialog = false">取消</el-button>
				<el-button type="primary" @click="saveAgent" :loading="saving">创建</el-button>
			</div>
		</el-dialog>

		<!-- MCP 服务器选择子弹窗 -->
		<el-dialog title="选择 MCP 服务器" :visible.sync="showMcpModal" width="520px"
			:append-to-body="true" custom-class="picker-sub-dialog">
			<div class="picker-list" v-loading="mcpLoading">
				<div class="picker-item" @click="pickTempMcp('')">
					<div class="radio" :class="{ 'checked': !tempMcpGuid }">
						<div class="radio-inner" v-if="!tempMcpGuid"></div>
					</div>
					<div class="picker-item-info">
						<div class="picker-item-name">不启用 MCP</div>
					</div>
				</div>
				<div v-for="server in mcpServerList" :key="server.guid" class="picker-item"
					@click="pickTempMcp(server.guid)">
					<div class="radio" :class="{ 'checked': tempMcpGuid === server.guid }">
						<div class="radio-inner" v-if="tempMcpGuid === server.guid"></div>
					</div>
					<div class="picker-item-info">
						<div class="picker-item-name">{{ server.serverName }}</div>
						<div class="picker-item-meta">
							{{ server.serverType }} · {{ (server.toolDefinitions || []).length }} 个工具
						</div>
					</div>
				</div>
				<div v-if="mcpServerList.length === 0 && !mcpLoading" class="picker-empty">
					该商户下暂无可用 MCP 服务器
				</div>
			</div>
			<div slot="footer">
				<el-button @click="closeMcpPicker">取消</el-button>
				<el-button type="primary" @click="confirmMcpPicker">确认</el-button>
			</div>
		</el-dialog>

		<!-- AI 模型选择子弹窗 -->
		<el-dialog title="选择 AI 模型" :visible.sync="showAiModelModal" width="520px"
			:append-to-body="true" custom-class="picker-sub-dialog">
			<div class="ai-vendor-tabs">
				<div v-for="vendor in aiVendors" :key="vendor.sign" class="ai-vendor-tab"
					:class="{ active: currentVendorSign === vendor.sign }"
					@click="switchVendor(vendor.sign)">
					{{ vendor.showName || vendor.show_name || vendor.name || vendor.sign }}
				</div>
			</div>
			<div class="picker-list ai-model-list" v-loading="aiModelLoading">
				<div class="picker-item" @click="pickTempAiModel('')">
					<div class="radio" :class="{ 'checked': !tempAiModelGuid }">
						<div class="radio-inner" v-if="!tempAiModelGuid"></div>
					</div>
					<div class="picker-item-info">
						<div class="picker-item-name">使用默认模型</div>
						<div class="picker-item-meta">不指定则使用系统默认模型</div>
					</div>
				</div>
				<div v-for="model in aiVendorModels" :key="model.guid" class="picker-item"
					@click="pickTempAiModel(model.guid)">
					<div class="radio" :class="{ 'checked': tempAiModelGuid === model.guid }">
						<div class="radio-inner" v-if="tempAiModelGuid === model.guid"></div>
					</div>
					<div class="picker-item-info">
						<div class="picker-item-name-row">
							<span class="picker-item-name">{{ model.modelName || model.modelCode }}</span>
							<span class="picker-item-price">每次 {{ model.usePrice || 0 }} 点</span>
						</div>
						<div class="picker-item-meta"
							v-if="model.modelCode && model.modelCode !== model.modelName">
							{{ model.modelCode }}
						</div>
					</div>
				</div>
				<div v-if="aiVendorModels.length === 0 && !aiModelLoading" class="picker-empty">
					该厂商下暂无可用模型
				</div>
			</div>
			<div slot="footer">
				<el-button @click="closeAiModelPicker">取消</el-button>
				<el-button type="primary" @click="confirmAiModelPicker">确认</el-button>
			</div>
		</el-dialog>
	</div>
	<!-- </el-aside> -->
	<!-- 创建/编辑智能体对话框 -->

</template>

<script>
import { removeChatDialog, updateChat, parseFromChatApi, getChatDialogs, setLunciTopApi } from '@/apis/chat';
import {
	createAgentApi,
	getCategoryListApi,
	getAgentMcpServerListApi,
	getAiVendorListApi,
	getAiVendorModelListApi,
} from '@/apis/agent';
import config from '@/apis/config';

// 仅内部智能体（agentType=1）用到的 MCP / AI 模型相关常量（与 my-agents.vue 保持一致）
const TOOL_NAME = 'ycyz_shop_product_search'
const DEFAULT_TOOL_DESC = '分析用户的意图，判断用户是否有购买商品、课程、其他产品的意愿，如果有，尽可能的全面的把意图拆分成多个搜索关键字，多个关键字用英文分号;进行分割，关键字尽量简单，最多保留最关键的5个关键字，适合用于数据库搜索'
const getToolName = (tool) => (tool && tool.function && tool.function.name) || (tool && tool.name) || '未命名工具'
const getToolDescription = (tool) => {
	const d = (tool && tool.function && tool.function.description) != null
		? tool.function.description
		: (tool && tool.description)
	return d == null ? '' : d
}
const setToolDescription = (tool, desc) => {
	if (tool && tool.function) tool.function.description = desc
	else if (tool) tool.description = desc
}

export default {
	name: 'layout-chat-left-v2',

	async mounted() {
		await this.loadCategoryList()
	},

	props: {
		_chatingId: String,
		_chatList: Array,
		_onChatState: Boolean,
		_creating: Boolean,
	},

	data() {
		return {
			config,
			defaultAvatar: 'https://ai-v2.deepcity.cn/default/head.png',
			uploading: false, // 头像上传中
			searchWord: '',
			showDialog: false,
			generating: false,
			agentForm: {
				merchantGuid: '',
				agentName: '',
				agentType: 1, // 默认内部类型
				categoryGuid: '',
				promptContent: '',
				agentDesc: '',
				agentAvatar: '',
				isPaid: 0, // 默认免费
				price: '',
				trial_chat_count: 0, // 试用聊天次数
				isPublic: 1, // 默认公开
				agentConfig: {
					deploy_address: '',
					coze_sign: '',
					secret_token: '',
					secret_key_type: 'default'
				},
				knowledgeBaseIds: [],
				welcomeMessage: '',
				commonQuestions: ['', '', ''], // 默认3个问题
				// 仅 agentType=1 内部智能体使用，提交时透传给后端，由后端合并到 agentConfig
				mcpServerGuid: '',
				customToolDefinitions: [],
				mcpConfigParam: [],
				toolDesc: '',
				aiModelGuid: '',
			},
			// MCP 已存值缓存（编辑/AI 生成回填后，等 MCP 列表加载完按 field 合并到模板）
			agentStoredMcpValues: [],

			// MCP 选择相关
			mcpServerList: [],
			mcpLoading: false,
			showMcpModal: false,
			tempMcpGuid: '',

			// AI 模型选择相关（厂商 tab + 模型列表）
			aiVendors: [],
			aiVendorModels: [],
			currentVendorSign: '',
			showAiModelModal: false,
			tempAiModelGuid: '',
			aiModelLoading: false,
			aiModelDetailCache: {},

			// 默认工具触发描述（template 占位符使用）
			DEFAULT_TOOL_DESC,

			saving: false,
			// 消息选择弹窗
			showMsgSelectDialog: false,
			loadingMessages: false,
			targetLunciGuid: '',
			chatMessages: [],
			selectedMsgIndexes: [],
			currentSystemPrompt: '',
			includeSystemPrompt: true,
			agentTypes: [
				{ value: 1, label: '内部智能体' },
				{ value: 2, label: 'Dify智能体' },
				{ value: 3, label: 'Coze智能体' },
			],
			// 可见性类型选项
			visibilityTypes: [
				{ value: 0, label: '免费' },
				{ value: 1, label: '付费' }
			],
			formRules: {
				agentName: [
					{ required: true, message: '请输入智能体名称', trigger: 'blur' },
					{ min: 2, max: 50, message: '长度在 2 到 50 个字符', trigger: 'blur' }
				],
				agentDesc: [
					{ required: true, message: '请输入描述', trigger: 'blur' },
					{ min: 10, max: 500, message: '长度在 10 到 500 个字符', trigger: 'blur' }
				],
				promptContent: [
					{ required: false, message: '请输入系统提示词', trigger: 'blur' },
				],
				categoryGuid: [
					{ required: true, message: '请选择分类', trigger: 'change' }
				],
				price: [
					{ required: false, message: '请输入价格', trigger: 'blur' },
					{ pattern: /^\d+(\.\d{1,2})?$/, message: '请输入正确的价格格式', trigger: 'blur' }
				]
			},
			categoryList: [],
		};
	},

	methods: {
		filter() {
			if (this.searchWord === '') {
				this._chatList.forEach(item => {
					item.visible = true;
				});
			} else {
				this._chatList.forEach(item => {
					item.visible = item.chatLunciTitle.includes(this.searchWord);
				});
			}
		},
		resetForm() {
			this.agentForm = {
				merchantGuid: this.merchantGuid,
				agentName: '',
				agentType: 1,
				categoryGuid: '',
				promptContent: '',
				agentDesc: '',
				agentAvatar: '',
				isPaid: 0,
				price: '',
				trial_chat_count: 0,
				isPublic: 1,
				agentConfig: {
					deploy_address: '',
					coze_sign: '',
					secret_token: '',
					secret_key_type: 'default'
				},
				knowledgeBaseIds: [],
				welcomeMessage: '',
				commonQuestions: ['', '', ''],
				mcpServerGuid: '',
				customToolDefinitions: [],
				mcpConfigParam: [],
				toolDesc: '',
				aiModelGuid: '',
			}
			this.agentStoredMcpValues = []
			this.editingAgent = null
			this.selectedCategory = null
			if (this.$refs.agentForm) {
				this.$refs.agentForm.clearValidate()
			}
		},
		// 加载分类列表
		async loadCategoryList() {
			try {
				const res = await getCategoryListApi({
					merchantGuid: this.$store.state.merchantGuid,
				})
				if (res && res.code === 0) {
					this.categoryList = res.data || []
				}
			} catch (error) {
				console.error('获取分类列表失败:', error)
			}
		},
		async saveAgent() {
			try {
				await this.$refs.agentForm.validate()

				// 表单验证
				if (!this.agentForm.categoryGuid) {
					this.$message.warning('请选择分类')
					return
				}

				if (!this.agentForm.agentName.trim()) {
					this.$message.warning('请输入智能体名称')
					return
				}

				if (this.agentForm.isPaid === 1 && !this.agentForm.price) {
					this.$message.warning('付费智能体请输入价格')
					return
				}

				this.saving = true

				// 过滤空的引导问题
				const filteredQuestions = this.agentForm.commonQuestions.filter(q => q && q.trim())

				const submitData = {
					agentName: this.agentForm.agentName.trim(),
					agentType: this.agentForm.agentType,
					categoryGuid: this.agentForm.categoryGuid,
					promptContent: this.agentForm.promptContent ? this.agentForm.promptContent.trim() : '',
					agentDesc: this.agentForm.agentDesc ? this.agentForm.agentDesc.trim() : '',
					agentAvatar: this.agentForm.agentAvatar,
					isPaid: this.agentForm.isPaid,
					price: this.agentForm.isPaid === 1 ? parseFloat(this.agentForm.price) : 0,
					isPublic: 1, // 暂时都设为公开
					trial_chat_count: this.agentForm.trial_chat_count || 0,
					agentConfig: this.agentForm.agentConfig,
					knowledgeBaseIds: this.agentForm.knowledgeBaseIds,
					welcomeMessage: this.agentForm.welcomeMessage ? this.agentForm.welcomeMessage.trim() : '',
					commonQuestions: filteredQuestions
				}

				// MCP / AI 模型字段仅对内部智能体（agentType=1）生效
				if (this.agentForm.agentType === 1) {
					submitData.mcpServerGuid = this.agentForm.mcpServerGuid || ''
					submitData.customToolDefinitions = this.applyYcyzToolDescToTools(
						this.agentForm.customToolDefinitions || [],
						this.agentForm.toolDesc,
					)
					submitData.mcpConfigParam = (this.agentForm.mcpConfigParam || []).map(p => ({
						field: p.field,
						value: p.value != null ? p.value : '',
					}))
					submitData.aiModelGuid = this.agentForm.aiModelGuid || ''
				}

				// 创建模式
				submitData.merchantGuid = this.$store.state.merchantGuid
				const res = await createAgentApi(submitData)

				if (res && res.code === 0) {
					this.$message.success('创建成功')
					this.showDialog = false
					// 跳转到智能体页面，并切换到我的智能体tab
					this.$router.push('/app/agent?tab=my-agents')
				} else {
					this.$message.error(res?.msg || '创建失败')
				}

			} catch (error) {
				this.$message.error(res?.msg || '创建失败')
			} finally {
				this.saving = false
			}
		},
		// 第一步：拉取消息列表，打开选择弹窗
		async generateAgent(lunci) {
			const targetGuid = lunci?.guid
			if (!targetGuid) {
				this.$message.warning('请先选择一个对话')
				return
			}
			this.targetLunciGuid = targetGuid
			// 同步切换聊天窗口
			this.chooseChat(lunci)
			this.loadingMessages = true
			this.showMsgSelectDialog = true
			this.chatMessages = []
			this.selectedMsgIndexes = []
			// 从 lunci 对象直接取系统提示词
			this.currentSystemPrompt = lunci?.chatLunciPrompt || ''
			this.includeSystemPrompt = !!this.currentSystemPrompt
			try {
				const messages = await getChatDialogs({ chatLunciGuid: targetGuid, is_all: 1 })
				// 只保留有文字内容的 user/assistant 消息
				this.chatMessages = (messages || []).filter(
					m => ['user', 'assistant'].includes(m.chatRole) && m.chatContent
				)
				// 默认全选
				this.selectedMsgIndexes = this.chatMessages.map((_, i) => i)
			} catch (e) {
				this.$message.error('加载消息失败，请重试')
				this.showMsgSelectDialog = false
			} finally {
				this.loadingMessages = false
			}
		},

		toggleMsg(idx) {
			const pos = this.selectedMsgIndexes.indexOf(idx)
			if (pos === -1) {
				this.selectedMsgIndexes.push(idx)
			} else {
				this.selectedMsgIndexes.splice(pos, 1)
			}
		},

		toggleSelectAll() {
			if (this.selectedMsgIndexes.length === this.chatMessages.length) {
				this.selectedMsgIndexes = []
			} else {
				this.selectedMsgIndexes = this.chatMessages.map((_, i) => i)
			}
		},

		// 第二步：用户确认选择后调用生成接口
		async confirmMsgSelection() {
			if (this.selectedMsgIndexes.length === 0) {
				this.$message.warning('请至少选择一条消息')
				return
			}

			const selectedMessages = this.selectedMsgIndexes
				.sort((a, b) => a - b)
				.map(i => ({
					role:    this.chatMessages[i].chatRole,
					content: this.chatMessages[i].chatContent,
				}))

			this.generating = true
			try {
				const res = await parseFromChatApi({
					merchantGuid:     this.$store.state.merchantGuid,
					chatLunciGuid:    this.targetLunciGuid,
					selectedMessages,
					lunciSystemPrompt: this.includeSystemPrompt ? this.currentSystemPrompt : '',
				}, 180000)

				if (res && res.code === 0 && res.data) {
					const data = res.data
					this.agentForm = {
						merchantGuid:     data.merchantGuid || this.$store.state.merchantGuid,
						agentName:        data.agentName || '',
						agentType:        data.agentType || 1,
						categoryGuid:     data.categoryGuid || '',
						promptContent:    data.promptContent || '',
						agentDesc:        data.agentDesc || '',
						agentAvatar:      data.agentAvatar || 'https://ai-v2.deepcity.cn/default/head.png',
						isPaid:           data.isPaid || 0,
						price:            data.price || 0,
						trial_chat_count: data.trial_chat_count || 0,
						isPublic:         data.isPublic || 1,
						agentConfig:      data.agentConfig || {
							deploy_address: '', coze_sign: '', secret_token: '', secret_key_type: 'default'
						},
						knowledgeBaseIds: data.knowledgeBaseIds || [],
						welcomeMessage:   data.welcomeMessage || '',
						commonQuestions:  data.commonQuestions?.length > 0 ? data.commonQuestions : ['', '', ''],
						// AI 不处理这些字段，保持空让用户在弹窗里手动选
						mcpServerGuid: '',
						customToolDefinitions: [],
						mcpConfigParam: [],
						toolDesc: '',
						aiModelGuid: '',
					}
					this.agentStoredMcpValues = []
					this.showMsgSelectDialog = false
					this.showDialog = true
					// 弹窗打开后预拉 MCP / AI 厂商列表，picker 才有数据可选
					this.loadMcpServerListIfNeeded()
					this.loadAiVendorsIfNeeded()
					this.$message.success('生成完成')
				} else {
					this.$message.error(res?.msg || '生成失败')
				}
			} catch (e) {
				console.error('生成智能体失败:', e)
				this.$message.error('生成失败，请重试')
			} finally {
				this.generating = false
			}
		},

		async removeChatDialog(guid) {
			await removeChatDialog(guid);
			this.$emit('reloadList');
			this.$message({ message: '已删除', type: 'success' });
		},

		// 切换聊天轮次的置顶状态
		// 接口幂等：当前与目标一致时后端直接成功返回，无需前端二次判断
		async toggleLunciTop(item) {
			const targetIsTop = item.isTop ? 0 : 1;
			try {
				const res = await setLunciTopApi(item.guid, targetIsTop);
				if (res && res.code === 0) {
					this.$message({
						message: targetIsTop ? '已置顶' : '已取消置顶',
						type: 'success',
					});
					// 通知父组件重新拉取列表，让排序刷新
					this.$emit('reloadList');
				} else {
					this.$message.error((res && res.msg) || '操作失败');
				}
			} catch (e) {
				console.error('置顶操作失败:', e);
				this.$message.error('置顶操作失败，请重试');
			}
		},

		modifyDialog() {
			let self = this;

			let chatObj = this._chatList.find(item => item.guid == this._chatingId);
			let idx = this._chatList.findIndex(item => item.guid == self._chatingId);

			this.$prompt('', '修改对话', {
				inputValue: chatObj.chatLunciTitle,
				confirmButtonText: '确定',
				cancelButtonText: '取消',
			}).then(async ({ value }) => {
				await updateChat(chatObj.guid, value);
				this.$set(this._chatList[idx], 'chatLunciTitle', value);

				self.$message({
					showClose: true,
					message: '更新成功',
					type: 'success',
				});
			});
		},

		createChat() {
			if (this._creating) return;
			if (this._onChatState) {
				this.$emit('createChat');
			} else {
				this.$message({
					showClose: true,
					message: '有生成任务进行中，暂不可新增对话',
					type: 'warning',
				});
				return;
			}
		},

		chooseChat({ guid }) {
			if (this._onChatState) {
				this.$emit('update:_chatingId', guid);
			} else {
				this边$this.$message({
					showClose: true,
					message: '有生成任务进行中，暂不可切换',
					type: 'warning',
				});
				return;
			}
		},

		// 头像上传成功回调
		handleAvatarSuccess({ code, data }) {
			if (code === 0) {
				this.agentForm.agentAvatar = data
				this.$message.success('头像上传成功')
			} else {
				this.$message.error('头像上传失败')
			}
			this.uploading = false
		},

		// 头像上传前校验：仅允许 jpg/png/gif，<2MB
		beforeAvatarUpload(file) {
			const isImg = ['image/jpeg', 'image/png', 'image/gif'].includes(file.type)
			const isLt2M = file.size / 1024 / 1024 < 2
			if (!isImg) {
				this.$message.error('上传头像图片只能是 JPG/PNG/GIF 格式!')
				return false
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!')
				return false
			}
			this.uploading = true
			return true
		},

		// ============= MCP / AI 模型 加载与选择（与 my-agents.vue 对齐） =============

		// 仅在 MCP 列表为空时拉取（避免重复请求）
		async loadMcpServerListIfNeeded() {
			if (this.mcpServerList.length > 0) {
				if (this.agentForm.mcpServerGuid) this.hydrateMcpConfigParam()
				return
			}
			try {
				this.mcpLoading = true
				const res = await getAgentMcpServerListApi({
					merchantGuid: this.$store.state.merchantGuid,
				})
				this.mcpServerList = Array.isArray(res && res.data) ? res.data : []
				if (this.agentForm.mcpServerGuid) this.hydrateMcpConfigParam()
			} catch (e) {
				console.error('获取 MCP 服务器列表失败:', e)
				this.mcpServerList = []
				this.$message.error('获取 MCP 服务器列表失败')
			} finally {
				this.mcpLoading = false
			}
		},

		async loadAiVendorsIfNeeded() {
			if (this.aiVendors.length === 0) {
				try {
					const res = await getAiVendorListApi({
						merchantGuid: this.$store.state.merchantGuid,
					})
					this.aiVendors = Array.isArray(res && res.data) ? res.data : []
					if (this.aiVendors.length > 0 && !this.currentVendorSign) {
						this.currentVendorSign = this.aiVendors[0].sign
					}
				} catch (e) {
					console.error('获取 AI 厂商列表失败:', e)
					this.aiVendors = []
				}
			}
			if (this.currentVendorSign && this.aiVendorModels.length === 0) {
				await this.loadAiVendorModels(this.currentVendorSign)
			}
		},

		async loadAiVendorModels(vendorSign) {
			if (!vendorSign) return
			try {
				this.aiModelLoading = true
				const res = await getAiVendorModelListApi({
					modelVendorSign: vendorSign,
					modelType: 'text',
				})
				this.aiVendorModels = Array.isArray(res && res.data) ? res.data : []
				for (const m of this.aiVendorModels) {
					if (m.guid) {
						this.$set(this.aiModelDetailCache, m.guid, {
							modelName: m.modelName || '',
							companyName: m.companyName || '',
							usePrice: m.usePrice || 0,
						})
					}
				}
			} catch (e) {
				console.error('获取 AI 模型列表失败:', e)
				this.aiVendorModels = []
			} finally {
				this.aiModelLoading = false
			}
		},

		// 服务器 mcpConfigParam 模板 + 已存值（按 field 匹配，已存值优先）
		hydrateMcpConfigParam() {
			const srv = this.mcpServerList.find(s => s.guid === this.agentForm.mcpServerGuid)
			const template = srv && Array.isArray(srv.mcpConfigParam) ? srv.mcpConfigParam : []
			if (template.length === 0) {
				this.agentForm.mcpConfigParam = []
				return
			}
			const valueMap = {}
			for (const p of (this.agentStoredMcpValues || [])) {
				if (p && p.field) valueMap[p.field] = p.value != null ? p.value : ''
			}
			this.agentForm.mcpConfigParam = template.map(t => ({
				field: t.field,
				field_name: t.field_name || t.fieldName || t.field,
				desc: t.desc || '',
				value: valueMap[t.field] != null ? valueMap[t.field] : (t.value != null ? t.value : ''),
			}))
		},

		// 从 customToolDefinitions 中提取商品搜索工具的描述（编辑/AI 生成回填用）
		extractYcyzToolDesc(tools) {
			if (!Array.isArray(tools)) return ''
			const target = tools.find(t => getToolName(t) === TOOL_NAME)
			if (!target) return ''
			const d = getToolDescription(target)
			return d === DEFAULT_TOOL_DESC ? '' : d
		},
		// 把 toolDesc 注入到 customToolDefinitions 对应工具的 description 上
		applyYcyzToolDescToTools(tools, desc) {
			if (!Array.isArray(tools) || tools.length === 0) return tools
			const finalDesc = (desc || '').trim() || DEFAULT_TOOL_DESC
			return tools.map(t => {
				if (getToolName(t) === TOOL_NAME) {
					const clone = JSON.parse(JSON.stringify(t))
					setToolDescription(clone, finalDesc)
					return clone
				}
				return t
			})
		},

		// MCP 服务器选择弹窗
		openMcpPicker() {
			if (this.mcpServerList.length === 0) this.loadMcpServerListIfNeeded()
			this.tempMcpGuid = this.agentForm.mcpServerGuid || ''
			this.showMcpModal = true
		},
		closeMcpPicker() {
			this.showMcpModal = false
		},
		pickTempMcp(guid) {
			this.tempMcpGuid = guid || ''
		},
		confirmMcpPicker() {
			const newGuid = this.tempMcpGuid || ''
			if (newGuid === this.agentForm.mcpServerGuid) {
				this.showMcpModal = false
				return
			}
			this.agentForm.mcpServerGuid = newGuid
			const srv = this.mcpServerList.find(s => s.guid === newGuid)
			this.agentForm.customToolDefinitions = srv
				? JSON.parse(JSON.stringify(srv.toolDefinitions || []))
				: []
			this.agentStoredMcpValues = []
			this.hydrateMcpConfigParam()
			this.agentForm.toolDesc = ''
			this.showMcpModal = false
		},

		// AI 模型选择弹窗
		openAiModelPicker() {
			this.tempAiModelGuid = this.agentForm.aiModelGuid || ''
			this.loadAiVendorsIfNeeded()
			this.showAiModelModal = true
		},
		closeAiModelPicker() {
			this.showAiModelModal = false
		},
		switchVendor(sign) {
			if (this.currentVendorSign === sign) return
			this.currentVendorSign = sign
			this.loadAiVendorModels(sign)
		},
		pickTempAiModel(guid) {
			this.tempAiModelGuid = guid || ''
		},
		confirmAiModelPicker() {
			this.agentForm.aiModelGuid = this.tempAiModelGuid || ''
			this.showAiModelModal = false
		},
		clearAiModel() {
			this.agentForm.aiModelGuid = ''
		},
	},

	computed: {
		// 当前选中的 MCP 服务器
		currentMcpServer() {
			return this.mcpServerList.find(s => s.guid === this.agentForm.mcpServerGuid)
		},
		currentMcpServerName() {
			const srv = this.currentMcpServer
			return srv ? `${srv.serverName}（${srv.serverType}）` : ''
		},
		// 当前选中的 AI 模型展示文案
		currentAiModelLabel() {
			if (!this.agentForm.aiModelGuid) return ''
			const info = this.aiModelDetailCache[this.agentForm.aiModelGuid]
			if (!info) return '已选择模型'
			return `${info.modelName}${info.companyName ? '（' + info.companyName + '）' : ''}`
		},
	},

	filters: {
		truncate(val, len = 80) {
			if (!val) return ''
			return val.length > len ? val.slice(0, len) + '...' : val
		}
	},
};
</script>

<style lang="scss" scoped>
.system-prompt-section {
	border: 1px solid #e0e3f5;
	border-radius: 6px;
	padding: 10px 12px;
	margin-bottom: 14px;
	background: #f8f9ff;

	.system-prompt-header {
		display: flex;
		align-items: center;
		gap: 8px;
		cursor: pointer;

		.system-prompt-label {
			font-size: 13px;
			font-weight: 600;
			color: #4958ec;
		}

		.system-prompt-hint {
			font-size: 12px;
			color: #999;
		}
	}

	.system-prompt-preview {
		margin-top: 8px;
		font-size: 12px;
		color: #666;
		line-height: 1.6;
		padding-left: 24px;
	}
}

.msg-loading {
	text-align: center;
	padding: 40px 0;
	color: #999;
}

.generate-tip {
	font-size: 12px;
	color: #f56c6c;
	text-align: right;
	margin-bottom: 8px;
}

.msg-select-tip {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 12px;
	font-size: 13px;
	color: #666;
}

.msg-select-list {
	max-height: 420px;
	overflow-y: auto;
}

.msg-select-item {
	display: flex;
	align-items: flex-start;
	gap: 10px;
	padding: 10px 12px;
	border-radius: 6px;
	margin-bottom: 6px;
	cursor: pointer;
	border: 1px solid #eee;
	transition: background 0.15s;

	&:hover {
		background: #f5f7ff;
	}

	&.selected {
		background: #f0f2ff;
		border-color: #c0c6f5;
	}

	&.is-user .msg-role {
		color: #4958ec;
	}

	.msg-body {
		flex: 1;
		min-width: 0;
	}

	.msg-role {
		font-size: 12px;
		font-weight: 600;
		color: #67c23a;
		margin-right: 6px;
	}

	.msg-content {
		font-size: 13px;
		color: #333;
		line-height: 1.5;
		word-break: break-all;
	}
}

.layout-chat-left {
	width: 250px;
	flex-shrink: 0;
	border-right: solid 1px var(--border-color);
	padding: 10px;
	background: rgb(250 251 255);
	background-color: #fff;
	overflow-y: auto;
	box-sizing: border-box;
	display: flex;
	flex-direction: column;
	position: relative;

	.chats-panel {
		flex: 1;
		padding-bottom: 68px;
		overflow-x: hidden;
		overflow-y: auto;

		.chat-item-box {
			.chat-icon-box {
				margin-bottom: 10px;

				.opts {
					width: 100%;
					display: flex;

					// justify-content: space-around;
					.item {
						display: flex;
						align-items: center;
						justify-content: center;
						margin: 0 10px;
						cursor: pointer;
						font-size: 12px;
						color: #999999;
					}
				}
			}
		}


	}

	.add-chat-btn {
		width: 225px;
		height: 40px;
		display: flex;
		justify-content: center;
		align-items: center;
		background: linear-gradient(90deg, #f5eefe 0%, #edeefd 53%, #e8effe 100%);
		color: #4958ec;
		font-size: 14px;
		border-radius: 8px;
		position: absolute;
		left: 10px;
		bottom: 10px;
		cursor: pointer;

		.icon {
			display: block;
			width: 20px;
			height: 20px;
			margin-right: 10px;
		}
	}

	.chat-item {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px;
		// border: solid 1px var(--border-color);
		// background: white;
		background-color: #fafbfc;
		border-radius: 6px;
		margin-bottom: 8px;

		.chat-name-box {
			flex: 1;
			cursor: pointer;
		}

		.opts {
			color: var(--text-black-light);
		}

		.name {
			font-size: 15px;
			font-weight: bold;
			margin-bottom: 4px;
			color: var(--text-black);

			.top-flag {
				color: #f56c6c;
				margin-right: 4px;
				font-size: 14px;
				vertical-align: middle;
			}
		}

		.date-row {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 8px;
		}

		.date {
			font-size: 12px;
			color: var(--text-black-light);
		}

		.top-btn {
			display: inline-flex;
			align-items: center;
			gap: 2px;
			font-size: 12px;
			color: #999;
			cursor: pointer;
			padding: 2px 6px;
			border-radius: 4px;
			transition: all 0.15s;

			i {
				font-size: 12px;
			}

			&:hover {
				color: #4958ec;
				background: rgba(73, 88, 236, 0.08);
			}

			&.active {
				color: #f56c6c;

				&:hover {
					color: #f56c6c;
					background: rgba(245, 108, 108, 0.08);
				}
			}
		}

		&.active,
		&:hover {
			//border: solid 1px var(--primary);
			// background: var(--primary-light);

			.name {
				// color: var(--primary);
				color: #4958ec;
			}

			.opts {
				color: #4958ec;
			}
		}
	}
}

@media screen and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) {
	.layout-chat-left {
		width: 200px;

		.chat-item {
			padding: 4px;
			margin-bottom: 40px;
			position: relative;

			// flex-direction: column;
			// align-items: start;
			.name {
				font-size: 12px;
			}

		}



	}
}

/* ─────── 头像上传（与 my-agents.vue 一致） ─────── */
.avatar-upload-section {
	display: flex;
	align-items: center;
	gap: 12px;

	.avatar-preview {
		.avatar-uploader {
			.el-upload {
				border: none;
				border-radius: 6px;
				cursor: pointer;
				position: relative;
				overflow: hidden;
			}

			.relative {
				position: relative;
				display: inline-block;
			}

			.avatar-image {
				width: 64px;
				height: 64px;
				border-radius: 6px;
				object-fit: cover;
				border: 2px solid #e0e0e0;
				display: block;
			}

			.uploading {
				position: absolute;
				top: 0;
				left: 0;
				width: 64px;
				height: 64px;
				border-radius: 6px;
				background: rgba(0, 0, 0, 0.6);
				color: white;
				font-size: 16px;
				display: flex;
				align-items: center;
				justify-content: center;

				.spin {
					animation: rotating 2s linear infinite;
				}
			}

			.btn-edit {
				position: absolute;
				bottom: -2px;
				right: -2px;
				width: 20px;
				height: 20px;
				background: #409eff;
				border-radius: 50%;
				display: flex;
				align-items: center;
				justify-content: center;
				color: white;
				font-size: 10px;
				cursor: pointer;

				&:hover {
					background: #66b1ff;
				}
			}
		}
	}
}

@keyframes rotating {
	from { transform: rotate(0deg); }
	to { transform: rotate(360deg); }
}

/* ─────── 主 Dialog 内：MCP / AI 模型选择触发器 + 参数列表（与 my-agents.vue 一致） ─────── */
.picker-trigger {
	height: 36px;
	padding: 0 12px;
	border: 1px solid #DCDFE6;
	border-radius: 4px;
	background: #fff;
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: border-color 0.2s;

	&:hover {
		border-color: #c0c4cc;
	}

	.picker-text {
		flex: 1;
		font-size: 14px;
		color: #303133;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		&.placeholder {
			color: #c0c4cc;
		}
	}

	.picker-arrow,
	.picker-clear {
		color: #c0c4cc;
		font-size: 14px;
		margin-left: 8px;
	}

	.picker-clear {
		cursor: pointer;
		padding: 4px;

		&:hover {
			color: #f56c6c;
		}
	}
}

.form-tip {
	font-size: 12px;
	color: #909399;
	line-height: 1.4;
	margin-top: 6px;
}

.mcp-param-list {
	display: flex;
	flex-direction: column;
	gap: 12px;

	.mcp-param-item {
		.mcp-sub-label {
			font-size: 13px;
			color: #606266;
			margin-bottom: 6px;
		}
	}
}
</style>

<!-- 子 Dialog 样式（append-to-body 后脱离当前 scope，所以独立 non-scoped 块） -->
<style lang="scss">
.picker-sub-dialog {
	.el-dialog__body {
		padding: 0;
	}

	.ai-vendor-tabs {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		padding: 12px 16px;
		border-bottom: 1px solid #f0f0f0;

		.ai-vendor-tab {
			padding: 6px 14px;
			border-radius: 16px;
			background: #f4f6f9;
			font-size: 13px;
			color: #555;
			cursor: pointer;
			transition: all 0.2s;
			user-select: none;

			&:hover {
				background: #ecf0f4;
			}

			&.active {
				background: #7848f1;
				color: #fff;
			}
		}
	}

	.picker-list {
		max-height: 400px;
		min-height: 200px;
		overflow-y: auto;

		&.ai-model-list {
			max-height: 360px;
		}

		.picker-item {
			display: flex;
			align-items: center;
			padding: 12px 16px;
			border-bottom: 1px solid #f5f5f5;
			cursor: pointer;
			transition: background 0.15s;

			&:hover {
				background: #fafbfc;
			}

			&:last-child {
				border-bottom: none;
			}

			.radio {
				width: 16px;
				height: 16px;
				border: 1.5px solid #ccc;
				border-radius: 50%;
				margin-right: 12px;
				display: flex;
				align-items: center;
				justify-content: center;
				flex-shrink: 0;

				&.checked {
					border-color: #7848f1;
				}

				.radio-inner {
					width: 8px;
					height: 8px;
					background: #7848f1;
					border-radius: 50%;
				}
			}

			.picker-item-info {
				flex: 1;
				min-width: 0;

				.picker-item-name-row {
					display: flex;
					align-items: center;
					justify-content: space-between;
				}

				.picker-item-name {
					font-size: 14px;
					color: #303133;
					font-weight: 500;
				}

				.picker-item-price {
					font-size: 12px;
					color: #7848f1;
					font-weight: 500;
					margin-left: 12px;
					flex-shrink: 0;
				}

				.picker-item-meta {
					font-size: 12px;
					color: #909399;
					margin-top: 4px;
				}
			}
		}

		.picker-empty {
			padding: 60px 20px;
			text-align: center;
			font-size: 13px;
			color: #909399;
		}
	}
}
</style>
